import { gql, makeVar } from '@apollo/client'
import { User } from '@core/auth/hooks/use-profile/use-profile.hook.types'

export const user = makeVar<User | null>(null)

export const setUser = (_user: User) => user(_user)

export const GET_PROFILE = gql`
  query user {
    user @client
  }
`
